// ==================导入所有样式文件=================
import './wui-form/src/Form.scss'; // form样式放所有表单组件前，确保权值相同时组件样式优先级高于form样式
import './wui-alert/src/Alert.scss';
import './wui-anchor/src/Anchor.scss';
import "./wui-avatar/src/Avatar.scss";
import './wui-backtop/src/BackTop.scss';
import './wui-badge/src/Badge.scss';
import './wui-breadcrumb/src/Breadcrumb.scss';
import './wui-button-group/src/ButtonGroup.scss';
import './wui-button/src/Button.scss';
import './wui-calendar/src/Calendar.scss';
import "./wui-card/src/Card.scss";
import './wui-carousel/src/CarouselFigure.scss';
import './wui-cascader/src/Cascader.scss';
import './wui-checkbox/src/Checkbox.scss';
import './wui-clipboard/src/Clipboard.scss';
import './wui-collapse/src/Collapse.scss';
import './wui-colorpicker/src/ColorPicker.scss';
import './wui-core/scss/index.scss';
import './wui-datepicker/src/DatePicker.scss';
import './wui-divider/src/Divider.scss';
import './wui-drawer/src/Drawer.scss';
import './wui-dropdown/src/Dropdown.scss';
import "./wui-empty/src/Empty.scss"
import './wui-icon/src/Icon.scss';
import './wui-image/src/Viewer.scss';
import './wui-input-group/src/InputGroup.scss';
import './wui-input-number/src/InputNumber.scss';
import './wui-input/src/Input.scss';
import './wui-layout/src/Layout.scss';
import './wui-list/src/List.scss';
import './wui-menu/src/Menu.scss';
import './wui-message/src/Message.scss';
import './wui-modal/src/Modal.scss';
import './wui-notification/src/Notification.scss';
import './wui-overlay/src/Overlay.scss';
import './wui-pagination/src/Pagination.scss';
import './wui-popconfirm/src/Popconfirm.scss';
import './wui-popover/src/Popover.scss';
import './wui-progress/src/index.scss';
import './wui-radio/src/Radio.scss';
import './wui-rate/src/Rate.scss';
import './wui-select/src/Select.scss';
import './wui-skeleton/src/Skeleton.scss';
import './wui-slider/src/Slider.scss';
import './wui-space/src/Space.scss';
import './wui-spin/src/Loading.scss';
import './wui-steps/src/Steps.scss';
import './wui-svgicon/src/SvgIcon.scss';
import './wui-switch/src/Switch.scss';
import './wui-table/src/Index.scss';
import './wui-tabs/src/Tabs.scss';
import './wui-tag/src/Tag.scss';
import './wui-timeline/src/Timeline.scss';
import './wui-timepicker/src/TimePicker.scss';
import './wui-tooltip/src/Tooltip.scss';
import './wui-transfer/src/Transfer.scss';
import './wui-tree/src/Tree.scss';
import './wui-treeselect/src/TreeSelect.scss';
import './wui-upload/src/Upload.scss';
import './wui-autocomplete/src/AutoComplete.scss'; // autocomplete基于select封装，样式优先于select和tree-select
